module.exports = "<i\nclass=\"fa fa-{{ name }}\"\naria-hidden=\"true\"\n[ngClass]=\"optionalClasses\"\n></i>"